import React from "react";

import PaymentInfo from "../../components/VendorProfile/PaymentInfo/Index";
import VendorHistory from "../../components/VendorProfile/VendorHistory/Index";
// import WholesalerHistory from "../../components/WholesalerProfile/WholesalerHistory/index";
import InvoiceHistory from "../../components/VendorProfile/InvoiceHistory/Index";
import MostPurchaseProducts from "../../components/VendorProfile/MosPurchaseProducts/Index.jsx";

const WholesalerProfile = (props) => {
  const {
    hideModal,
    dueCollectionData,
    activeTab,
    loadingCallback,
    fetchedData,
    invoiceData,
    customerId,
    onSubmitPayment,
    handleSubmitAddDue,
    handleSubmitAddPiad,
    handlePrintPdf,
    getDateWiseDueReport
  } = props;
  return (
    <>
      <div className="flex flex-col xl:flex-row gap-[3%]">
        <div className="w-[100%] xl:w-[300px] mb-[25px] xl:mb-0 bg-[#F8F9FA] rounded-[16px] p-3">
          <PaymentInfo
            activeTab={activeTab}
            hideModal={hideModal}
            loadingCallback={loadingCallback}
            fetchedData={fetchedData}
            invoiceData={invoiceData}
            onSubmitPayment={onSubmitPayment}
            dueCollectionData={dueCollectionData}
            handleSubmitAddDue={handleSubmitAddDue}
            handleSubmitAddPiad={handleSubmitAddPiad}
            setSuccessFlashMessage={props.setSuccessFlashMessage}
            setErrorFlashMessage={props.setErrorFlashMessage}
            setWarningMessage={props.setWarningMessage}
            handlePrintPdf={props.handlePrintPdf}
            getDateWiseDueReport={getDateWiseDueReport}
            setReportBtn={props.setReportBtn}
            reportBtn={props.reportBtn}
            setFromDate={props.setFromDate}
            setToDate={props.setToDate}
            fromDate={props.fromDate}
            toDate={props.toDate}
            paymentList={props.paymentList}
            paymentAccountList={props.paymentAccountList}
            type="wholesaler"
          />
        </div>
        <div className="flex-1">
          <VendorHistory
            activeTab={activeTab}
            loadingCallback={loadingCallback}
            fetchedData={fetchedData}
            type="wholesaler"
          />

          <MostPurchaseProducts
            activeTab={activeTab}
            loadingCallback={loadingCallback}
            fetchedData={fetchedData}
            vendorId={customerId}
            type="wholesaler"
          />

          <InvoiceHistory
            activeTab={activeTab}
            loadingCallback={loadingCallback}
            invoiceData={invoiceData}
            vendorId={customerId}
            type="wholesaler"
          />
        </div>
      </div>
    </>
  );
};

export default WholesalerProfile;
